export default "__VITE_ASSET__ad152063__"